<Page name="byTopic" 
  infinite
  infiniteDistance={30}
  infinitePreloader={showPreloader}
  onInfinite={loadMore}
  on:resize={() => fResize()}
  >
    <Header />
    <div id="print-topic-list">
      <Row>
        <Col width="100">
          <BlockTitle style="float: left;">Topic</BlockTitle>
        </Col>
      </Row>
      <div style="margin-left:15px;">
        <input bind:value={inputKeywords} 
                  on:keyup={() => setTimeout(handleInput('keywords'), 400)} 
                  on:change={()=> setTimeout(handleInput('keywords'), 400)}
                  on:inputEmpty={() => console.log('empty')}
                  class="inline wv-select"
                  type="String" 
                  placeholder="Keywords"
                  style="background-color: white; padding: 8px 10px;
                  box-shadow:0.5px 1px 1px 1px #cecece; width: 200px;
                  color: rgb(81 145 206); text-transform: uppercase;">
        <Button class="btn-print btn-print-tools inline"
                style="width:180px; display:inline-block;"
                onClick={() => fPrintDivById('print-topic-list')}><i class="icon f7-icons">printer</i> Print This List</Button>
      </div>
    <div class="filter-grades" style="max-width: 1000px; margin-left:15px; margin-top: 20px;">
        <div>
          {#if isMobile }
            {#each arroTopicFilterOption as option}
              <Button active={option.isActive} on:click={() => handleTopicFilter('topicType', option)}>{option.display}</Button>
            {/each}
          {:else}
            <Segmented strong tag="p">
              {#each arroTopicFilterOption as option}
                <Button active={option.isActive} on:click={() => handleTopicFilter('topicType', option)}>{option.display}</Button>
              {/each}
            </Segmented>
          {/if}
        </div>
    </div>
  {#if arroFilteredTopic }
  <Row>
    <Col>
      <List ul={false}>
        <ListGroup>
          {#each arroFilteredTopic as oTopic}
          <!-- <ListItem title="Group Title" groupTitle></ListItem> -->
            <ListItem>
              <Link class="header-link nav-link" href="/topic/{oTopic.key}" style="padding:0;">
                {oTopic.value.topic || oTopic.value.title}
              </Link>
            </ListItem>
          {/each}
        </ListGroup>
      </List>
    </Col>
  </Row>
  {/if}
</div>
<Row><Footer/></Row>
</Page>
<script>
  import {
    Page,
    Navbar,
    NavLeft,
    NavRight,
    NavTitle,
    List,
    ListGroup,
    ListItem,
    Button,
    Preloader,
    Link,
    Block,
    Row,
    Col,
    SwipeoutActions,
    SwipeoutButton,
    BlockTitle,
    Segmented
  } from 'framework7-svelte';
  import { pluralize, fPrintDivById } from '../utils';
  import Header from '../components/Header.svelte';
  import Footer from '../components/Footer.svelte';
  import { getContext, onDestroy } from 'svelte';
  import { query, searchData } from '../stores.js';

  let page = 1;
  let items;
  let currentItem;
  let allowInfinite = true;
  let showPreloader = false;
  let sQuery = '';
  let grade;
  let isShowFilter = true;
  let isMobile = true;
  let inputKeywords="";

  let oData; 
  let oFilter;
  let arroTopic;
  let arroFilteredTopic;
  let ARROTOPICCONSTANT;

  let arroTopicFilterOption = [
    {id:"all", display: "All", isActive: true },
    {id:"Counseling", display: "Counseling", isActive: false },
    {id:"Preventive", display: "Preventive Medication", isActive: false },
    {id:"Screening", display: "Screening", isActive: false }
  ];

  $: showPreloader = (items) ? (items.length < 299) ? true : false : false;
  $: fResize();

  const unsubscribeSearchData = searchData.subscribe(obj => {
    oData = obj;
    if (!oData) { return; }
    ARROTOPICCONSTANT = Object.entries(oData.generalRecommendations).map(([key, value]) => ({key,value}));
    arroTopic = ARROTOPICCONSTANT;
    arroFilteredTopic = fSortTopic(arroTopic);
  });

  onDestroy(unsubscribeSearchData);

  function fSortTopic(arr) {
    return arr.sort((a, b) =>a.value.topic.localeCompare(b.value.topic));
  }

  function fResize() {
    if (window.innerWidth > 850) {
      isMobile = false;
    } else {
      isMobile = true;
    }
  }

  window.addEventListener("resize", fResize);

  function handleInput (key) {
    handleTopicFilter(key);
  }


  // Filter
  function filterByKeywords(topic) {
    var isincluded = false;
    var keywords = inputKeywords && inputKeywords.toLowerCase();
    // split keywords by space and quotes
    var arrsKeyword = keywords && keywords.match(/(".*?"|[^"\s]+)+(?=\s*|\s*$)/g);

    arrsKeyword && arrsKeyword.forEach(keyword => {
      const key = keyword.replace(/['"]+/g, '');
      if ((topic.value && topic.value.title.toLowerCase().includes(key)) ||
          (topic.value && topic.value.keywords.toLowerCase().includes(key))) {
            isincluded = true;
      }
    });
    return isincluded;
  }

  function handleTopicFilter(key, value) {

    // Reset topic array
    arroTopic = ARROTOPICCONSTANT;

    // Filter by keywords
    if (inputKeywords) {
      arroTopic = arroTopic.filter(filterByKeywords);
    }

    if (key == 'topicType') {
      if (!arroTopic || !value.id) { return; }
      arroTopicFilterOption.forEach(opt => {
        if (opt.id === value.id) {
          opt.isActive = true;
        } else {
          opt.isActive = false;
        }
      });
      if (value.id === 'all') {
        arroFilteredTopic = fSortTopic(arroTopic);
      } else {
        const arroFiltered = arroTopic.filter(oTopic => oTopic.value.topicType.includes(value.id));
        arroFilteredTopic = fSortTopic(arroFiltered);
      }

      arroTopicFilterOption = arroTopicFilterOption;
      value.isActive = true;
    } else {
      arroFilteredTopic = fSortTopic(arroTopic);
    }
  }

  function loadMore() {
    if (!allowInfinite) return;
    allowInfinite = false;

    if (!showPreloader) return;
    
    page += 1;
  }
</script>
<style>
</style>